import React from 'react'
import './About.scss'
import SectionTitle from '../../components/SectionTitle/SectionTitle'

function About() {
  return (
    <>
    <SectionTitle />
    </>
    
  )
}

export default About;